export default __webpack_public_path__ + "static/buch03-e7c574b34458a7a4efae1cca8fa4f729.jpg";